import { Button } from '@agro1desenvolvimento/react-components';
import { FC, useMemo } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import navigateToAqila1 from '../../utils/navigate-to-aqila1';

type Error = {
  title: string;
  subtitle: string;
  description: string;
};

const ErrorPage: FC<{ isNotFound?: boolean }> = ({ isNotFound = false }) => {
  const routeError = useRouteError();

  const error: Error = useMemo(() => {
    if (
      (isRouteErrorResponse(routeError) && routeError.status === 404) ||
      isNotFound
    ) {
      return {
        title: '404',
        subtitle: 'Página não encontrada',
        description:
          'A página não foi encontrada, por favor confira se o endereço está correto, ou tente atualizar a página.',
      };
    }

    return {
      title: 'Erro inesperado',
      subtitle: 'Algo de errado aconteceu',
      description:
        'Um erro inesperado aconteceu ao tentar acessar o recurso solicitado.',
    };
  }, [routeError, isNotFound]);

  return (
    <div className="error-page">
      <h1>{error.title}</h1>
      <hr />
      <div className="content">
        <h2>{error.subtitle}</h2>
        <p>{error.description}</p>
      </div>
      <div className="actions">
        <Button
          label="Voltar a página inicial"
          className="button-primary"
          onClick={() => navigateToAqila1()}
        />
      </div>
    </div>
  );
};

export default ErrorPage;
